export enum CallStatus {
  PENDING = "pending",
  CREATED = "created",
  CONNECTING = "connecting",
  CONNECTED = "connected",
  END = "end",
  DISCONNECTED = "disconnected",
}

export enum VideoCallProvider {
  DOLBY = "Dolby",
  DAILY = "Daily",
}
